export default __webpack_public_path__ + "static/media/avatar_tommy_pyper8.6f700ff7.mp3";